var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeftWhite = function SvgArrowLeftWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14,
    viewBox: "0 0 18 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.28 9.06H4.99l4.29 4.83-1.31 1.17-6.69-7 6.69-7 1.31 1.16-4.29 4.84h14.29z",
    transform: "translate(-1.28 -1.06)"
  })));
};
export { SvgArrowLeftWhite as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE4IDE0Ij4KICAgIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0xOS4yOCA5LjA2SDQuOTlsNC4yOSA0LjgzLTEuMzEgMS4xNy02LjY5LTcgNi42OS03IDEuMzEgMS4xNi00LjI5IDQuODRoMTQuMjl6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMS4yOCAtMS4wNikiLz4KPC9zdmc+Cg==";